module.exports = __webpack_public_path__ + "img/jingdianjianjie.1ebc4f4f.png";